import { NgModule } from '@angular/core';
import { OvGenericModule } from '@ov-suite/ui';
import { CustomerGroup } from '@ov-suite/models-admin';

@NgModule({
  imports: [
    OvGenericModule.forRoot({
      entity: CustomerGroup,
      api: 'adminlink',
      createTitle: 'Customer Group',
      route: ['customer-group'],
      tableTitle: 'Customer Group',
      tabs: [
        {
          path: '/customer',
          title: 'Customer',
        },
        {
          path: '/customer-group',
          title: 'Customer Group',
        },
      ],
      permissionId: 903,
    }),
  ],
})
export class CustomerGroupModule {}
